const setShowSalesPopup = (context, showSalesPopup) => {
  context.commit('SET_SHOW_SALES_POPUP', showSalesPopup);
};

const setShowThematicBanner = (context, showThematicBanner) => {
  context.commit('SET_SHOW_THEMATIC_BANNER', showThematicBanner);
};

const setShowLibraryBanner = (context, showLibraryBanner) => {
  context.commit('SET_SHOW_LIBRARY_BANNER', showLibraryBanner);
};

const setShowIslandBanner = (context, showIslandBanner) => {
  context.commit('SET_SHOW_ISLAND_BANNER', showIslandBanner);
};

export default {
  setShowSalesPopup,
  setShowThematicBanner,
  setShowLibraryBanner,
  setShowIslandBanner,
};
